export default __webpack_public_path__ + "static/media/guest-services.ec32bf20.svg";